'use strict';

var React = require('react');

var SvgFlipCameraMajor = function SvgFlipCameraMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.059 1a1.5 1.5 0 0 0-1.32.786l-.54 1c-.039.07-.07.142-.096.214h-3.603a1.5 1.5 0 0 0-1.5 1.5v11a1.5 1.5 0 0 0 1.5 1.5h17a1.5 1.5 0 0 0 1.5-1.5v-11a1.5 1.5 0 0 0-1.5-1.5h-3.621a1.546 1.546 0 0 0-.1-.223l-.55-1a1.5 1.5 0 0 0-1.315-.777h-5.854zm4.692 14.08c-.63.278-1.311.42-2 .42a5.016 5.016 0 0 1-4.975-4.5h-1.275a.5.5 0 0 1-.405-.795l2.27-3.145a.5.5 0 0 1 .81 0l2.275 3.145a.5.5 0 0 1-.4.8h-1.25a3.014 3.014 0 0 0 2.95 2.495c.32 0 .637-.05.94-.15l1.33 1.6c-.09.05-.18.09-.27.13zm2.884-2.14 2.265-3.14a.5.5 0 0 0-.405-.8h-1.275a5.016 5.016 0 0 0-4.975-4.5 4.941 4.941 0 0 0-2.27.55l1.33 1.6c.303-.1.62-.15.94-.15a3.014 3.014 0 0 1 2.95 2.505h-1.25a.5.5 0 0 0-.4.795l2.28 3.14a.5.5 0 0 0 .81 0z"
  }));
};

exports.SvgFlipCameraMajor = SvgFlipCameraMajor;
